import styled from 'styled-components'

import { EmptyStateBanner } from '@/features/dashboard/components/Banner/EmptyStateBanner'

import { PageContainer, PageTitle } from '../styles'

const ACCESS_IT_URL = 'https://accessit.equinor.com/Search/Search?term=iiot'
const IIOT_SUPPORT_EMAIL = 'gm_TDI_IIoT_Sensors@equinor.com'

interface NoAccessProps {
    // The plant to request access for. Omitted for the "all plants" (admin) view.
    plantName?: string
}

const NoAccess = ({ plantName }: NoAccessProps) => (
    <AccessPageContainer>
        <PageTitle variant="h1">Plant status</PageTitle>
        {plantName ? (
            <EmptyStateBanner
                title={`You don't have access to plant status for ${plantName}.`}
                message={
                    <>
                        Request access at{' '}
                        <AccessLink href={ACCESS_IT_URL} target="_blank" rel="noopener noreferrer">
                            AccessIT
                        </AccessLink>{' '}
                        and select {plantName} Write.
                    </>
                }
            />
        ) : (
            <EmptyStateBanner
                title="Viewing plant status for all plants requires admin access."
                message={
                    <>
                        Please contact the IIoT team at{' '}
                        <AccessLink href={`mailto:${IIOT_SUPPORT_EMAIL}`}>{IIOT_SUPPORT_EMAIL}</AccessLink>
                        <br />
                        if you believe this access is relevant to your role.
                    </>
                }
            />
        )}
    </AccessPageContainer>
)

const AccessPageContainer = styled(PageContainer)`
    & > [role='status'] {
        width: fit-content;
        max-width: 100%;
    }
`

const AccessLink = styled.a`
    color: inherit;
    text-decoration: underline;
`

export default NoAccess
